export default __webpack_public_path__ + "static/media/concrete-driveway.0e0be409.jpeg";